$(document).ready(function(){
    // Instantiate EasyZoom instances
    // var $easyzoom = $('.easyzoom').easyZoom();
    var object_name = {
        init : function(){
            // call method which was registed bellow,
            // more than 20 line code create a new method.
            object_name.method_register_event();
        },
        method_register_event : function(){
            $(document).on('click','.quick-view',function(e){
                e.preventDefault();
                var $this = $(this);
                $this.children('i').addClass('loading');
                var handle = $this.data('handle');
                setTimeout(function(){
                    if (handle) {
                        var product_data = object_name.get_product(handle);
                        object_name.update_modal(product_data);
                        $('#modal-quickview').modal('show');
                        setTimeout(function(){
                            object_name.run_slick();
                            $this.children('i').removeClass('loading');
                        },500);
                    }
                },500);          
                
            });

        },
        get_product : function(handle){
            var result = '';
            $.ajax({
                type:'get',
                url: 'https://'+window.location.hostname+'/products/'+handle+'?view=data-quickview',
                async: false,
                success : function(response){
                    result = response;
                }
            })
            return result;
        },
        update_modal : function(data){
            $('#modal-quickview .modal-quickview-inner').html($(data).find('.content.quick-view').html());
        },
        run_slick : function(){
            initSingle('#modal-quickview .large-image','#modal-quickview .small-image');
            gallery();
            // star review
            $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
        }

    }
    object_name.init();
});

